export default {
  // 'WHATSAPP.TEMPLATE.LIST.TITLE': 'WhatsApp templates',
  'WHATSAPP.TEMPLATE.LIST.MARKET': 'Marketing',
  'WHATSAPP.TEMPLATE.LIST.UTILITY': 'Utility',
  'WHATSAPP.TEMPLATE.LIST.ADD.TEMPLATE': 'Create WhatsApp template',
  'WHATSAPP.TEMPLATE.LIST.STATUS.ALL': 'All statuses',
  'WHATSAPP.TEMPLATE.LIST.STATUS.DRAFT': 'Draft',
  'WHATSAPP.TEMPLATE.LIST.STATUS.APPROVED': 'Approved',
  'WHATSAPP.TEMPLATE.LIST.STATUS.REJECTED': 'Rejected',
  'WHATSAPP.TEMPLATE.LIST.STATUS.PENDING': 'Pending',
  'WHATSAPP.TEMPLATE.LIST.STATUS.PAUSED': 'Paused',
  'WHATSAPP.TEMPLATE.LIST.STATUS.DISABLED': 'Disabled',

  'WHATSAPP.TEMPLATE.MANAGE.NAME': 'Template name',
  'WHATSAPP.TEMPLATE.MANAGE.LANGUAGE': 'Language',
  'WHATSAPP.TEMPLATE.MANAGE.QUALITY': 'Quality',
  'WHATSAPP.TEMPLATE.MANAGE.CONTENT': 'Content',
  'WHATSAPP.TEMPLATE.MANAGE.STATUS': 'Status',
  'WHATSAPP.TEMPLATE.MANAGE.ACTION': 'Action',

  'WHATSAPP.TEMPLATE.LIST.QUALITY.GREEN': 'High',
  'WHATSAPP.TEMPLATE.LIST.QUALITY.YELLOW': 'Medium',
  'WHATSAPP.TEMPLATE.LIST.QUALITY.RED': 'Low',
  'WHATSAPP.TEMPLATE.LIST.QUALITY.UNKNOWN': 'Quality pending',

  'WHATSAPP.TEMPLATE.MANAGE.STATUS.PLACEHOLDER': 'Template status',

  'WHATSAPP.TEMPLATE.LIST.DELETE.DIALOG.HEADER': 'Delete WhatsApp template?',
  'WHATSAPP.TEMPLATE.LIST.DELETE.DIALOG.BODY':
    "<b class='color-333'>'<span>{name}</span>'</b> will be permanently deleted and cannot be restored.",

  'WHATSAPP.TEMPLATE.LIST.PREVIEW.TITLE': 'Preview',

  'WHATSAPP.TEMPLATE.LIST.CREATE.TITLE.MARKETING':
    'Create WhatsApp marketing template',
  'WHATSAPP.TEMPLATE.LIST.CREATE.TITLE.UTILITY':
    'Create WhatsApp utility template',

  'WHATSAPP.TEMPLATE.MANAGE.CREATE.LANGUAGE': 'Template language',
  'WHATSAPP.TEMPLATE.MANAGE.CREATE.LANGUAGE.PLACEHOLDER':
    'Select template language',
  'WHATSAPP.TEMPLATE.MANAGE.CREATE.SENDER.NUMBER': 'Sender number',
  'WHATSAPP.TEMPLATE.MANAGE.CREATE.SENDER.SELECT.PLACEHOLDER':
    'Please select associated account',
  'WHATSAPP.TEMPLATE.LIST.CREATE.NAME.UNABLE.EMPTY': 'enter template name',
  'WHATSAPP.TEMPLATE.LIST.CREATE.NAME.UNABLE.CHARACTER':
    'Only allows lowercase letters, numbers, and _',
  'WHATSAPP.TEMPLATE.LIST.CREATE.NAME.UNABLE.REPEAT':
    'Name cannot be a duplicate',

  'WHATSAPP.TEMPLATE.LIST.CREATE.BUTTON.SUBMIT.APPROVAL': 'Submit for approval',

  'WHATSAPP.TEMPLATE.CREATE.HEADER.TEXT': 'Enter header text here',
  'WHATSAPP.TEMPLATE.CREATE.BODY.TEXT': 'Enter footer text here',
  'WHATSAPP.TEMPLATE.CREATE.ADD.BUTTONS': 'Add buttons',
  'WHATSAPP.TEMPLATE.CREATE.BUTTON.TEXT': 'Enter button text here',
  'WHATSAPP.TEMPLATE.CREATE.BUTTON.URL': 'Enter URL here',
  'WHATSAPP.TEMPLATE.CREATE.BUTTON.TEXT.REPEAT':
    "You can't enter the same text for multiple buttons",
  'WHATSAPP.TEMPLATE.CREATE.BUTTON.URL.UNABLE.EMPTY':
    'You must enter a valid URL. Please check for spelling errors and ensure the URL starts with http://, https://, or whatsapp-smb://.',

  'WHATSAPP.TEMPLATE.CREATE.HEADER.TEXT.SPECIAL.ERROR':
    "Headers can't have any line breaks, characters formatting, emojis, or asterisks(*).",
  'WHATSAPP.TEMPLATE.CREATE.BUTTON.TEXT.SPECIAL.ERROR':
    "Buttons can't have any line breaks, characters formatting or emojis.",

  'WHATSAPP.TEMPLATE.CREATE.FOOTER.TEXT.SPECIAL.ERROR':
    "Footers can't have any line breaks, characters formatting, emojis, or asterisks(*).",

  'WHATSAPP.TEMPLATE.CREATE.FOOTER.TEXT.UNABLE.EMPTY': 'Cannot be empty',

  'WHATSAPP.TEMPLATE.CREATE.HEADER.TEXT.INPUT': 'Enter header text here',
  'WHATSAPP.TEMPLATE.CREATE.BODY.TEXT.INPUT': 'Enter body text here',
  'WHATSAPP.TEMPLATE.CREATE.FOOTER.TEXT.INPUT': 'Enter footer text here',
  'WHATSAPP.TEMPLATE.CREATE.HEADER.MEDIA.UPLOAD': 'Upload image',

  'WHATSAPP.TEMPLATE.LIST.CREATE.BUTTON.SUBMIT.APPROVAL.ERROR':
    'Failed to get template data, please check the template content',
  'WHATSAPP.TEMPLATE.LIST.CREATE.BUTTON.SUBMIT.APPROVAL.SUCCESS':
    'Submitted for approval',

  'WHATSAPP.TEMPLATE.LIST.CREATE.SELECT.SENDER.NUMBER.TIPS.SUCCESS':
    'Choose which sender account will be used to submit for approval.',
  'WHATSAPP.TEMPLATE.LIST.CREATE.TITLE.TIPS': 'Configure WhatsApp Template',
  'WHATSAPP.TEMPLATE.LIST.CREATE.HEADER': 'Header',
  'WHATSAPP.TEMPLATE.LIST.CREATE.HEADER.TEXT': 'Text',
  'WHATSAPP.TEMPLATE.LIST.CREATE.HEADER.MEDIA': 'Media',
  'WHATSAPP.TEMPLATE.LIST.CREATE.BODY': 'Body',
  'WHATSAPP.TEMPLATE.LIST.CREATE.FOOTER': 'Footer',
  'WHATSAPP.TEMPLATE.LIST.CREATE.BUTTON': 'Button',
  'WHATSAPP.TEMPLATE.LIST.CREATE.BUTTON.ADD.TIPS':
    'Add buttons to let recipients take quick actions (e.g. visit a website), with up to 2 supported.',

  'WHATSAPP.TEMPLATE.MANAGE.ADD.TEMPLATE.TITLE':
    'Create your first WhatsApp template',
  'WHATSAPP.TEMPLATE.MANAGE.ADD.TEMPLATE.DES':
    'After creating a template, it can be used in campaigns.',
  'WHATSAPP.TEMPLATE.MANAGE.ADD.TEMPLATE': 'Create WhatsApp template',
  'WHATSAPP.TEMPLATE.MANAGE.BUTTON.TEXT': 'Button Text',
  'WHATSAPP.TEMPLATE.MANAGE.BUTTON.URL': 'URL Address',
  'WHATSAPP.TEMPLATE.MANAGE.BUTTON.TEXT.UNABLE.EMPTY':
    'Button text cannot be empty',
  'WHATSAPP.TEMPLATE.MANAGE.BUTTON.TEXT.INPUT': 'Enter button text',
  'WHATSAPP.TEMPLATE.MANAGE.BUTTON.URL.UNABLE.EMPTY':
    'URL address cannot be empty',
  'WHATSAPP.TEMPLATE.MANAGE.BUTTON.URL.INPUT': 'Enter URL address',
  'WHATSAPP.TEMPLATE.CREATE.SAVE.DRAFT.TITLE': 'Save changes',
  'WHATSAPP.TEMPLATE.CREATE.SAVE.DRAFT.DESC':
    'Save changes made to this template.',

  'WHATSAPP.TEMPLATE.EDITING.TIPS': '*Only 1 person can be editing at a time',
  'WHATSAPP.TEMPLATE.CREATE.BODY.TEXT.CONTACT.ERROR':
    'Contact attributes are not permitted to appear at the beginning or the end.',
  'WHATSAPP.TEMPLATE.CREATE.BODY.TEXT.VAR.ERROR':
    'The total number of words in the body text should be controlled to be more than three times the total number of contact attributes.',
  'WHATSAPP.TEMPLATE.CREATE.CONTACT.FIELD.ERROR.TITLE.APPROVAL':
    'Confirm to submit for approval?',
  'WHATSAPP.TEMPLATE.CREATE.CONTACT.FIELD.ERROR.TITLE.SAVE': 'Confirm to save?',
  'WHATSAPP.TEMPLATE.CREATE.CONTACT.FIELD.ERROR.DESC.TIPS1':
    'Detected template contains',
  'WHATSAPP.TEMPLATE.CREATE.CONTACT.FIELD.ERROR.DESC.TIPS1.1':
    'exist in the template. ',
  'WHATSAPP.TEMPLATE.CREATE.CONTACT.FIELD.ERROR.DESC.TIPS2':
    'If you need to insert contact attributes, <b>please select an existing contact</b> attribute to insert.',
  'TEMPLATE.ADD.VARIABLE.DIALOG.CONTACT.LABEL.DES.WHATSAPP':
    'After the message is sent, the contact information in the system will be used for replacement.',
  'WHATSAPP.TEMPLATE.CREATE.TEXT.TIP.LIMIT':
    'The maximum character limit has been exceeded.',
  'WHATSAPP.TEMPLATE.CREATE.CONTACT.FIELD.ERROR.TITLE.SAVE.ERROR':
    'Save failed.',
  'WHATSAPP.TEMPLATE.CREATE.CONTACT.FIELD.ERROR.TITLE.APPROVAL.ERROR':
    'Submission failed.',
};
